import React, { memo } from 'react';
import { StatefulTooltip } from "baseui/tooltip";

// recoil 
import { useRecoilValue, useRecoilState } from 'recoil'
import { isBuilder, screen, screenOpen } from "@/store/builder/store";
import { settings } from "@/store/template/settings";


function HeroAuthor() {

  // recoil
  const getSettings = useRecoilValue(settings);
  const builder = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)

  const handleClick = () => {
    setScreen('author')
    setScreenOpen(true)
  };

  return (

    <>

      {/* if builder add tool tip */}

      {
        builder && getSettings.author.hide == 'show' &&
        <StatefulTooltip content={() => "Edit Author"} showArrow placement="left">
          <div onClick={handleClick} className="inline-flex bg-black bg-opacity-10 py-2 px-4 rounded  mr-5  items-center hover:opacity-75 hover:scale-105 transform transition duration-300 ease-in-out cursor-pointer">

            {
              getSettings.author.photo &&
              <img className="inline-block h-12 w-12 rounded-full mr-4" src={getSettings.author.photo} alt="Author photo" />
            }

            <div>
              <div className="heroExpertName font-bold svelte-djl91p expertNameWhite">
                {getSettings.author.name}
              </div>
              <div className="font-medium text-sm  opacity-90">
                {getSettings.author.tag}
              </div>
            </div>
          </div>
        </StatefulTooltip>
      }

      {/* not in builder */}

      {
        !builder && getSettings.author.hide == 'show' &&
        <div className="inline-flex mr-10 mt-5 items-center hover:scale-105 transform transition duration-300 ease-in-out cursor-pointer">
          {
            getSettings.author.photo &&
            <img className="inline-block h-12 w-12 rounded-full mr-4" src={getSettings.author.photo} alt="Author photo" />
          }
          <div>
            <div className="heroExpertName font-bold svelte-djl91p expertNameWhite">
              {getSettings.author.name}
            </div>
            <div className="font-medium text-sm mt-0.5 opacity-75">
              {getSettings.author.tag}
            </div>
          </div>
        </div>
      }


    </>

  )

}

export default memo(HeroAuthor);
